const initialState = {
    pending: false,
    fields: [],
    error: null,
    selected: {}
};

const fieldsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_FIELDS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_FIELDS_SUCCESS':
            return {
                ...state,
                pending: false,
                fields: action.fields
            };
        case 'GET_FIELDS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_FIELD':
            return {
                ...state,
                selected: action.selected
            };
        default:
            return state;
    }
};

export default fieldsReducer;
